import axiosInstance from '@/plugins/api/axiosInstance';
import generateQueryParams from '@/utils/generateQueryParams';

export default function companySteps() {
    return {
        index
    };

    function index(options = {}) {
        const defaultValues = {
            pattern: ''
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`status/steps${params}`);
    }
}
